import React from 'react';
import classnames from 'classnames';

function Notification() {
  return (
    <div className={classnames(
      'Notification'
    )}>
      <h3>ETHWaterloo winner <span role="img" aria-label="tada">🎉</span></h3>
      <p>Rufflet is Mixpanel for smart contracts by the <a href='https://www.cryptokitties.co'>CryptoKitties</a> team.</p>

      <p><strong>Get notified when we release the real-time full-featured version:</strong></p>


      <form action="http://www.mailzen.io/59e5529e78294f00126e1885" method="post">
        <input
          class="Input"
          style={{ marginBottom: '.5rem' }}
          type="email"
          name="email"
          placeholder="Type your email"
        />
        <input
          type="text"
          name="__mailzen__"
          style={{ display: 'none'}}
        />
        <input
          class="Button Button--full"
          type="submit"
          value="Notify me"
        />
      </form>
    </div>
  );
}

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification.js